import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="G" transform="translate(11.000000, 5.000000)">
        <path
          d="M49.5,45.8 L40.8,45.8 L40.8,50.2 L44.2,50.2 C44.2,53.1 42.1,54.8 39.2,54.8 C35.4,54.8 33.1,52.2 33.1,45.6 C33.1,39.0 35.4,36.4 39.2,36.4 C41.8,36.4 43.7,37.8 44.0,40.1 L49.3,39.4 C48.6,34.2 44.8,31.0 39.2,31.0 C32.2,31.0 27.5,35.8 27.5,45.6 C27.5,55.4 32.2,60.2 39.2,60.2 C45.8,60.2 49.5,56.0 49.5,49.8 L49.5,45.8 Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
